import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

import { colors } from "@dotnet/telematics-design-system";

const DisabledIcon = (props: SvgIconProps) => {
    const { gray50, gray300 } = colors;

    return (
        <SvgIcon {...props}>
            <rect
                x="2.5"
                y="2.5"
                width="19"
                height="19"
                rx="9.5"
                fill={gray50}
                stroke={gray300}
            />
        </SvgIcon>
    );
};

export default DisabledIcon;
